<template>
    <div class="manager_dashboard">
        <user-menu />
        <div class="wrapper">
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div class="db-card">
                        <flash-message autoHide variant="success"></flash-message>
                        <div class="row justify-content-lg-center justify-content-xl-center">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div class="circle">
                                            <label class="initials">{{ initialAvatar(firstName, lastName) }}</label>
                                        </div>
                                        <div class="db-mentee-name">{{ firstName + ' ' + lastName }}</div>
                                        <div class="db-mentor-name">Mentor: <span>{{ mentorName.join(', ') }}</span></div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Status: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_val">{{ userTypeName }}</div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Email Address: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_val">{{ email }}</div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Phone Number: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_val">{{ phoneNo }}</div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Assign Task List(s)<span class="required">*</span>: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="custom-control custom-checkbox" v-for="(taskList, tindex) in taskLists" :key="tindex">
                                            <input 
                                                type="checkbox" 
                                                class="custom-control-input" 
                                                name="Assign Task List"
                                                :id="'assign_task_list_' + tindex"
                                                v-validate="'required'"
                                                :value="taskList.id"
                                                :checked="taskList.checked"
                                                v-model="tasks_selected"
                                                @click="getTasklistSelected(taskList, $event)">
                                            <label class="custom-control-label" :for="'assign_task_list_' + tindex">{{ taskList.name }}</label>
                                        </div>
                                        <div v-show="verrors.has('Assign Task List')" class="validate-warning-msg">{{ verrors.first('Assign Task List') }}</div>
                                    </div>
                                </div>
                                <div class="text-center mt-4">
                                    <button type="submit" class="btn btn-sm btn-blue text-center saveBtn" @click="doUpdateMentee()">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
export default {
    data(){
        return{
            tasks_selected: [],
            taskLists: [],
            tasklistSelected: [],
            menteeTasklist: [],
            firstName: '',
            lastName: '',
            email: '',
            phoneNo: '',
            status: '',
            mentorName: [],
            user_type: '',
            program: 'Mentorship',
            userTypeName: '',
            account_user_status: '',
        }
    },
    methods:{
        initialAvatar(firstname, lastname) {
          var initial = '';
          initial = firstname.charAt(0) + lastname.charAt(0);
          return initial.toUpperCase();
        },
        getTasklistSelected(taskList, event) {        
            if(event.value == true) {
                this.tasklistSelected.push(taskList.id);
            }
            else {
                const removeItem = taskList.id;
                const removeItemIndex = this.tasklistSelected.indexOf(removeItem);
                this.tasklistSelected.splice(removeItemIndex, 1); 
            }
            //console.log(this.tasklistSelected)
        },
        doUpdateMentee() {
            const menteeId = this.$route.params.mentee_id;
            this.$validator.validateAll().then((result) => {
                if(!result) {
                    return;
                }
                axios('/desktop/mentor/mentee-profile-edit',
                {
                    method: 'POST',
                    data: {
                    "mentee_id" : menteeId,
                    "tasklists_assigned": this.tasks_selected,
                    "account_id": this.$store.state.user_accountid,
                    }
                },
                )
                .then(()=> {
                    this.flash({ message: 'Profile updated successfully', variant: 'success' });
                    this.$router.push(this.$router.currentRoute.path)
                    this.$router.go();
                })
                .catch(() => {
                });
            }).catch(() => {
                // catches the error;
            });
        },
    },
    components: {
        UserMenu,
        GoBack,
        AdminSidebarMenu,
    },
    created() {
        const menteeId = this.$route.params.mentee_id;
       
        axios.get('/alltasklists-account', {    
            params: {
                account_id: this.$store.state.user_accountid,
            }    
        })
        .then(response =>  {
          this.taskLists = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
        setTimeout(()=>{
        axios.get('/desktop/mentee-details/' + menteeId + '/' + this.$store.state.user_accountid, {
       
        })
        .then(response =>  {
          this.firstName = response.data.mentee_first_name;
          this.lastName = response.data.mentee_last_name;
          this.email = response.data.mentee_email;
          this.phoneNo = response.data.mentee_phone_no;
          this.status = response.data.mentee_status;
          this.account_user_status = response.data.mentee_account_status;
          this.goals = response.data.mentee_goals;
          this.menteeTasklist = response.data.mentee_tasklist;
          this.menteeAssessment = response.data.mentee_assessment;
          this.user_type = response.data.user_type;
          for(var i=0; i < response.data.groups.length; i++) {
            this.mentorName.push(response.data.groups[i].name);
          }
          for( i=0; i<this.taskLists.length; i++) {
            if(this.menteeTasklist.indexOf(this.taskLists[i].id) > -1) {
              this.taskLists[i].checked = true;
              this.tasks_selected.push(this.taskLists[i].id);
            }
            else {
              this.taskLists[i].checked = false;
            }
          }
            var userTypeName = "Mentee";
            var userRole = "ROLE_MENTEE";
            if (this.user_type == 'apprentice') {
                userRole = "ROLE_MENTEE";
                userTypeName = "Apprentice";
            }
            if (this.account_user_status == 'Active') {
                this.userTypeName = userTypeName + ' - Active';
            } else {
                this.userTypeName = userTypeName + ' - Inactive';
            }
        })
        .catch(function(error) {
          console.log(error);
        });
        }, 1500);
    },
}
</script>
<style scoped>
.db-card {
  color: #002F42;
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
  margin-top: 10px;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 10px;
  margin-left: 10px;
}
.grid_row .cols { padding: 0; }
.db-card .label_txt {
  font-weight: 900;
  margin-bottom: 5px;
}
.circle {
  background-color: #A5A5A5;
  border-radius: 30px;
  text-align: center;
  width: 60px;
  height: 60px;
  margin-right: 5px;
  float: left;
}
.initials {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  position: relative;
  transform: translateY(22px);
  color: #FFF;
  display: inline-block;
  vertical-align: middle;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #29A3E4 !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
</style>


// WEBPACK FOOTER //
// src/components/mentor/mentor_mentee_profile.vue